export default "immagini/destination-benchmark-logo.svg"